module.exports = __webpack_public_path__ + "img/banner.ff50c5b6.png";